import { TFunction } from 'i18next';

import { getSortingOptions } from '../../../../../../common/global/helpers';
import { SortOption } from '../../../../../../common/global/models';
import { SortingOrderTypes } from '../../../../enums';
import { resources } from '../../../../resources/resources';
import { SortValue } from './common';

export const getInitialSortValue = (
  translate: TFunction,
  isDiscountVoucherList: boolean,
  isBenefitBucksList: boolean,
  isSearchResults: boolean,
  initialSortId?: number,
): SortValue => {
  if (!initialSortId) {
    return getDefaultSortValue(isSearchResults, translate);
  }
  return getSortingOptions(
    isDiscountVoucherList,
    isBenefitBucksList,
    isSearchResults,
  )
    .map((opt: SortOption) => {
      return {
        id: opt.id,
        text: translate(opt.resource),
      };
    })
    .find(e => e.id === initialSortId)!;
};

export const getDefaultSortValue = (
  isSearchResults: boolean,
  translate: TFunction,
): SortValue => {
  if (isSearchResults) {
    return {
      id: SortingOrderTypes.TheMostRelevant,
      text: `${translate(
        resources.flexibleBenefits.products.sortingOptions.theMostRelevant,
      )}`,
    };
  }
  return {
    id: SortingOrderTypes.TheMostPopular,
    text: `${translate(
      resources.flexibleBenefits.products.sortingOptions.theMostPopular,
    )}`,
  };
};
